module.exports = __webpack_public_path__ + "static/themeable_month-dd62860baf63ad4b116e1479cefdd58e.png";